module.exports = __webpack_public_path__ + "static/media/motor_cycle.1e3a3395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/motor_cycle.svg
// module id = 531
// module chunks = 0